var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_284_1358",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5259 5.80622C17.1316 6.6739 17.5415 7.66288 17.7271 8.70468H20V11.2953H17.7271C17.5415 12.3371 17.1316 13.3261 16.5259 14.1938L18.1337 15.8017L16.3017 17.6337L14.6938 16.0259C13.8261 16.6316 12.8371 17.0415 11.7953 17.2271V19.5H9.20468V17.2271C8.16288 17.0415 7.1739 16.6316 6.30622 16.0259L4.69835 17.6337L2.86627 15.8017L4.47415 14.1938C3.8684 13.3261 3.45851 12.3371 3.27287 11.2953H1V8.70468H3.27287C3.45851 7.66288 3.8684 6.6739 4.47415 5.80622L2.86627 4.19835L4.69835 2.36627L6.30622 3.97415C7.1739 3.3684 8.16288 2.95851 9.20468 2.77287V0.5H11.7953V2.77287C12.8371 2.95851 13.8261 3.3684 14.6938 3.97415L16.3017 2.36627L18.1337 4.19835L16.5259 5.80622Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.375C11.1299 12.375 11.734 12.1248 12.1794 11.6794C12.6248 11.234 12.875 10.6299 12.875 10C12.875 9.37011 12.6248 8.76602 12.1794 8.32062C11.734 7.87522 11.1299 7.625 10.5 7.625C9.87011 7.625 9.26602 7.87522 8.82062 8.32062C8.37522 8.76602 8.125 9.37011 8.125 10C8.125 10.6299 8.37522 11.234 8.82062 11.6794C9.26602 12.1248 9.87011 12.375 10.5 12.375Z",
    fill: "black",
    stroke: "black",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_284_1358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.899902 -1.39999H21.9001V21.4H-0.899902V-1.39999Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsblack);
export default __webpack_public_path__ + "static/media/settingsblack.0f0fc2afbb188c10bd46cfc04050d709.svg";
export { ForwardRef as ReactComponent };